var _g, _g2, _g3, _path, _rect, _path2, _g4, _path3, _g5, _path4, _g6, _path5, _g7, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPagination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 90,
    viewBox: "0 0 451 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8801_16332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 60,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-180 70 60)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8801_16332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7882 35.7138L48.7821 44.7048C49.1768 45.0984 49.8162 45.0984 50.2118 44.7048C50.6065 44.3111 50.6065 43.6717 50.2118 43.2781L41.9313 35.0005L50.2108 26.723C50.6055 26.3294 50.6055 25.69 50.2108 25.2953C49.8162 24.9017 49.1758 24.9017 48.7812 25.2953L39.7872 34.2862C39.3986 34.6758 39.3986 35.3253 39.7882 35.7138Z",
    fill: "#737373"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8801_16332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 10,
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.212 34.2862L402.218 25.2952C401.823 24.9016 401.184 24.9016 400.788 25.2952C400.394 25.6889 400.394 26.3283 400.788 26.7219L409.069 34.9995L400.789 43.277C400.395 43.6706 400.395 44.31 400.789 44.7047C401.184 45.0983 401.824 45.0983 402.219 44.7047L411.213 35.7138C411.601 35.3242 411.601 34.6747 411.212 34.2862Z",
    fill: "#737373"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 60,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-180 131 60)",
    fill: "#617AF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.494 27.7031V42H105.688V29.959L102.045 31.2871V29.6562L107.211 27.7031H107.494Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8801_16332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 60,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-180 191 60)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.873 40.5156V42H161.566V40.7012L166.225 35.5156C166.798 34.8776 167.24 34.3372 167.553 33.8945C167.872 33.4453 168.093 33.0449 168.217 32.6934C168.347 32.3353 168.412 31.9707 168.412 31.5996C168.412 31.1309 168.314 30.7077 168.119 30.3301C167.93 29.946 167.65 29.64 167.279 29.4121C166.908 29.1842 166.459 29.0703 165.932 29.0703C165.3 29.0703 164.773 29.194 164.35 29.4414C163.933 29.6823 163.62 30.0208 163.412 30.457C163.204 30.8932 163.1 31.3945 163.1 31.9609H161.293C161.293 31.1602 161.469 30.4277 161.82 29.7637C162.172 29.0996 162.693 28.5723 163.383 28.1816C164.073 27.7845 164.923 27.5859 165.932 27.5859C166.83 27.5859 167.598 27.7454 168.236 28.0645C168.874 28.377 169.363 28.8197 169.701 29.3926C170.046 29.959 170.219 30.623 170.219 31.3848C170.219 31.8014 170.147 32.2246 170.004 32.6543C169.867 33.0775 169.675 33.5007 169.428 33.9238C169.187 34.347 168.904 34.7637 168.578 35.1738C168.259 35.584 167.917 35.9876 167.553 36.3848L163.744 40.5156H170.873Z",
    fill: "black",
    fillOpacity: 0.55
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8801_16332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 60,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-180 251 60)",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.193 34.002H225.482C226.114 34.002 226.635 33.8978 227.045 33.6895C227.462 33.4746 227.771 33.1849 227.973 32.8203C228.181 32.4492 228.285 32.0326 228.285 31.5703C228.285 31.0234 228.194 30.5645 228.012 30.1934C227.829 29.8223 227.556 29.5423 227.191 29.3535C226.827 29.1647 226.365 29.0703 225.805 29.0703C225.297 29.0703 224.848 29.1712 224.457 29.373C224.073 29.5684 223.77 29.8483 223.549 30.2129C223.334 30.5775 223.227 31.0072 223.227 31.502H221.42C221.42 30.7793 221.602 30.1217 221.967 29.5293C222.331 28.9368 222.842 28.4648 223.5 28.1133C224.164 27.7617 224.932 27.5859 225.805 27.5859C226.664 27.5859 227.416 27.7389 228.061 28.0449C228.705 28.3444 229.206 28.7936 229.564 29.3926C229.923 29.985 230.102 30.724 230.102 31.6094C230.102 31.9674 230.017 32.3516 229.848 32.7617C229.685 33.1654 229.428 33.543 229.076 33.8945C228.731 34.2461 228.282 34.5358 227.729 34.7637C227.175 34.985 226.511 35.0957 225.736 35.0957H224.193V34.002ZM224.193 35.4863V34.4023H225.736C226.641 34.4023 227.39 34.5098 227.982 34.7246C228.575 34.9395 229.04 35.2259 229.379 35.584C229.724 35.9421 229.965 36.3359 230.102 36.7656C230.245 37.1888 230.316 37.612 230.316 38.0352C230.316 38.6992 230.202 39.2884 229.975 39.8027C229.753 40.3171 229.438 40.7533 229.027 41.1113C228.624 41.4694 228.148 41.7396 227.602 41.9219C227.055 42.1042 226.459 42.1953 225.814 42.1953C225.196 42.1953 224.613 42.1074 224.066 41.9316C223.526 41.7559 223.048 41.502 222.631 41.1699C222.214 40.8314 221.889 40.418 221.654 39.9297C221.42 39.4349 221.303 38.8717 221.303 38.2402H223.109C223.109 38.735 223.217 39.168 223.432 39.5391C223.653 39.9102 223.965 40.1999 224.369 40.4082C224.779 40.61 225.261 40.7109 225.814 40.7109C226.368 40.7109 226.843 40.6165 227.24 40.4277C227.644 40.2324 227.953 39.9395 228.168 39.5488C228.389 39.1582 228.5 38.6667 228.5 38.0742C228.5 37.4818 228.376 36.9967 228.129 36.6191C227.882 36.235 227.53 35.9518 227.074 35.7695C226.625 35.5807 226.094 35.4863 225.482 35.4863H224.193Z",
    fill: "black",
    fillOpacity: 0.55
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_8801_16332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 60,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-180 311 60)",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.166 37.2148V38.6992H280.893V37.6348L287.26 27.7812H288.734L287.152 30.6328L282.943 37.2148H291.166ZM289.184 27.7812V42H287.377V27.7812H289.184Z",
    fill: "black",
    fillOpacity: 0.55
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_8801_16332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 60,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-180 371 60)",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M343.842 35.2324L342.396 34.8613L343.109 27.7812H350.404V29.4512H344.643L344.213 33.3184C344.473 33.1686 344.802 33.0286 345.199 32.8984C345.603 32.7682 346.065 32.7031 346.586 32.7031C347.243 32.7031 347.833 32.8171 348.354 33.0449C348.874 33.2663 349.317 33.5853 349.682 34.002C350.053 34.4186 350.336 34.9199 350.531 35.5059C350.727 36.0918 350.824 36.7461 350.824 37.4688C350.824 38.1523 350.73 38.7806 350.541 39.3535C350.359 39.9264 350.082 40.4277 349.711 40.8574C349.34 41.2806 348.871 41.6094 348.305 41.8438C347.745 42.0781 347.084 42.1953 346.322 42.1953C345.749 42.1953 345.206 42.1172 344.691 41.9609C344.184 41.7982 343.728 41.554 343.324 41.2285C342.927 40.8965 342.602 40.4863 342.348 39.998C342.1 39.5033 341.944 38.9238 341.879 38.2598H343.598C343.676 38.7936 343.832 39.2428 344.066 39.6074C344.301 39.972 344.607 40.2487 344.984 40.4375C345.368 40.6198 345.814 40.7109 346.322 40.7109C346.752 40.7109 347.133 40.6361 347.465 40.4863C347.797 40.3366 348.077 40.1217 348.305 39.8418C348.533 39.5618 348.705 39.2233 348.822 38.8262C348.946 38.429 349.008 37.9831 349.008 37.4883C349.008 37.0391 348.946 36.6224 348.822 36.2383C348.699 35.8542 348.513 35.5189 348.266 35.2324C348.025 34.946 347.729 34.7246 347.377 34.5684C347.025 34.4056 346.622 34.3242 346.166 34.3242C345.561 34.3242 345.102 34.4056 344.789 34.5684C344.483 34.7311 344.167 34.9525 343.842 35.2324Z",
    fill: "black",
    fillOpacity: 0.55
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8801_16332",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735625 0 0 0 0 0.798042 0 0 0 0 0.891667 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8801_16332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8801_16332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8801_16332",
    x: 361,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735625 0 0 0 0 0.798042 0 0 0 0 0.891667 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8801_16332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8801_16332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8801_16332",
    x: 121,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735625 0 0 0 0 0.798042 0 0 0 0 0.891667 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8801_16332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8801_16332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8801_16332",
    x: 181,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735625 0 0 0 0 0.798042 0 0 0 0 0.891667 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8801_16332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8801_16332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_8801_16332",
    x: 241,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735625 0 0 0 0 0.798042 0 0 0 0 0.891667 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8801_16332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8801_16332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_8801_16332",
    x: 301,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735625 0 0 0 0 0.798042 0 0 0 0 0.891667 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8801_16332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8801_16332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8801_16332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(55 45) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagination);
export default __webpack_public_path__ + "static/media/pagination.bbad8f5b7278d53df6ef3714df92a378.svg";
export { ForwardRef as ReactComponent };